module.exports = __webpack_public_path__ + "static/media/CIAJ2.1dffad62.png";